import React from 'react';
import styled from 'styled-components';
import { color } from '@nuvolo/nuux-theme/utils';
import TMMButton from '../TMMButton';
import { FilterChip } from './util';
import FAIcon from '#/common/components/FAIcon';

export const NotificationBubble = styled.div`
  position: absolute;
  border-radius: 20px;
  height: 17px;
  display: flex;
  padding: 4px;
  background-color: #dc143c; // custom color
  color: ${color('contrast', 'light')};
  justify-content: center;
  align-items: center;
  top: 0;
  right: -1px;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 100%;
  vertical-align: middle;
  font-family: Mulish;
  z-index: 2;
`;

const StyledTMMButton = styled(TMMButton)`
  .dx-button-content {
    padding: 12px !important;
  }
`;

export type FilterButtonProps = {
  activeFilters: FilterChip[];
  openFilter: () => void;
};

const FilterButton = ({ activeFilters, openFilter }: FilterButtonProps) => {
  return (
    <div style={{ position: 'relative' }}>
      {activeFilters.length > 0 && (
        <NotificationBubble>
          {activeFilters.length > 9 ? '9+' : activeFilters.length}
        </NotificationBubble>
      )}

      <StyledTMMButton onClick={openFilter} icon="filter" />
    </div>
  );
};

export default React.memo(FilterButton) as typeof FilterButton;
